import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import { PencilSquare, Person, Eye, CashStack, CheckCircleFill  } from "react-bootstrap-icons";
import ModalBooking from "../../components/vendors/ModalBooking";
import VendorLayout from "../../layout/HotelVendorLayout/VendorLayout";
import AppContext from "../../context/AppContext";
import { useNavigate } from "react-router-dom";
import "../../assets/css/vendors/HotelScreens/hotelBookings.css";

const viewBtnStyle = {
  display: "inline-flex",
  alignItems: "center",
  gap: "4px",
  padding: "5px 10px",
  fontSize: "11px",
  fontWeight: "600",
  border: "1px solid #4a6fa5",
  borderRadius: "6px",
  cursor: "pointer",
  background: "#fff",
  color: "#4a6fa5",
  transition: "all 0.18s ease",
};

const HotelBookings = () => {
const { authToken, baseUrl, vendorId, hotelId } = useContext(AppContext);
const navigate = useNavigate();
const [bookings, setBookings] = useState([]);
const [loadingList, setLoadingList] = useState(true);
const [filter, setFilter] = useState("All");
const [showModal, setShowModal] = useState(false);
const [selectedBooking, setSelectedBooking] = useState(null);
const [modalMode, setModalMode] = useState("edit");
const [loading, setLoading] = useState(false);

  const fetchBookings = (activeFilter) => {
    setLoadingList(true);

    const params = {
      status: activeFilter,
      vendor_id: vendorId,
      hotel_id: hotelId
    };

    axios
      .get(`${baseUrl}/vendor/view-booking`, {
        headers: { Authorization: `Bearer ${authToken}` },
        params,
      })
      .then((res) => {
        console.log(res.data);
        setBookings(res.data?.data || []);
      })
      .catch((err) => {
        console.error("Fetch error:", err);
        setBookings([]);
      })
      .finally(() => setLoadingList(false));
  };

  useEffect(() => {
    fetchBookings(filter);
  }, [filter]);

  const formatDate = (d) =>
    d
      ? new Date(d).toLocaleDateString("en-US", {
    year: "numeric", month: "long", day: "numeric", timeZone: "UTC",
        })
      : "N/A";

  const getStatusClass = (status) => {
    const map = {
      confirmed: "hotel-booking-status-confirmed",
      pending: "hotel-booking-status-pending",
      cancelled: "hotel-booking-status-cancelled",
      completed: "hotel-booking-status-completed",

    };
    return map[status?.toLowerCase()] || "";
  };

  const getRoomData = (booking) => {
if (booking.jjroom_id) {
        const allRooms = booking.jjvendor?.jjhotelregistration?.jjrooms || [];
        const bookedRoom = allRooms.find(room => room.id === booking.jjroom_id);
        if (bookedRoom) {
            return bookedRoom;
        }
    }
    return booking.jjvendor?.jjhotelregistration?.jjrooms?.[0] || null;
  };
  const openEditModal = (booking) => {
    setSelectedBooking(booking);
    setModalMode("edit");
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setSelectedBooking(null);
  };
const markPaymentReceived = (bookingId) => {
    axios
      .post(
        `${baseUrl}/vendor/booking-payment-received`,
        {
          booking_id: bookingId,
          vendor_id: vendorId,
        },
        { headers: { Authorization: `Bearer ${authToken}` } }
      )
      .then((res) => {
        if (res.data.success) {
          fetchBookings(filter);
        } else {
          alert(res.data.message || "Something went wrong");
        }
      })
      .catch(() => alert("Unable to connect to server"));
  };
  const saveBooking = (updatedData) => {
    setLoading(true);

    axios
      .post(
        `${baseUrl}/vendor/booking-update`,
        {
          booking_id: updatedData.booking_id,
          booking_status: updatedData.booking_status,
          room_id: updatedData.room_id,
          vendor_id: vendorId,
          hotel_id: hotelId
        },
        { headers: { Authorization: `Bearer ${authToken}` } }
      )
      .then((res) => {
        if (res.data.success) {
          fetchBookings(filter);
          closeModal();
        } else {
          alert(res.data.message || "Something went wrong");
        }
      })
      .catch(() => alert("Unable to connect to server"))
      .finally(() => setLoading(false));
  };

  if (loadingList) {
    return (
      <VendorLayout>
        <div className="hotel-booking-main-container">
          <div className="text-center p-5">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
            <p className="mt-3">Loading bookings...</p>
          </div>
        </div>
      </VendorLayout>
    );
  }

  return (
    <VendorLayout>
      <div className="hotel-booking-main-container">
        <div className="hotel-booking-container">

          {/* Header */}
          <div className="hotel-bookings-header">
            <div>
              <h3 className="hotel-bookings-title">All Bookings</h3>
              <p className="hotel-bookings-subtitle">
                Manage hotel bookings and reservations
              </p>
            </div>
          </div>

          {/* Filter Buttons */}
          <div className="hotel-filter-buttons-container">
            {["All", "confirmed", "pending", "cancelled", "completed"].map((status) => (
              <button
                key={status}
                onClick={() => setFilter(status)}
                className={`hotel-filter-button ${filter === status ? "hotel-filter-button-active" : ""
                  }`}
              >
                {status.charAt(0).toUpperCase() + status.slice(1)}
              </button>
            ))}
          </div>

          {/* Table */}
          <div className="hotel-bookings-table-wrapper">
            <table className="hotel-bookings-table">
              <thead>
                <tr>
                  <th>Customer</th>
                  <th>Hotel Name</th>
                  <th>Room No.</th>
                  <th>Check-In</th>
                  <th>Check-Out</th>
                  <th>Total Amount</th>
                  <th>Guests</th>
                  <th>Status</th>
                  <th style={{ width: "140px" }}>Actions</th>
                </tr>
              </thead>
              <tbody>
                {bookings.map((booking) => {
                  const roomData = getRoomData(booking);
                  const hotelData = booking.jjvendor?.jjhotelregistration;

                  return (
                    <tr key={booking.id}>

                      <td data-label="Customer">
                        <div className="hotel-booking-guest">
                          <Person className="hotel-guest-icon" />
                          <div>
                            <span className="hotel-guest-name">
                              {booking.jjcustomer?.cus_username || "N/A"}
                            </span>
                            <br />
                            <small className="text-muted">
                              {booking.jjcustomer?.cus_email || ""}
                            </small>
                          </div>
                        </div>
                      </td>

                      <td data-label="Hotel Name">
                        {hotelData?.hotel_name || "N/A"}
                      </td>

                      <td data-label="Room No.">
                        {roomData?.room_number || "N/A"}
                      </td>

                      <td data-label="Check-In">
                        {formatDate(booking.checkIn)}
                      </td>

                      <td data-label="Check-Out">
                        {formatDate(booking.checkOut)}
                      </td>

                      <td data-label="Total Amount">
                        <div className="fw-semibold text-success">
                          PKR {(booking.total_amount|| 0).toLocaleString()}
                        </div>
                         <small className="text-muted d-block">
                             Reserved: PKR {(booking.reservation_amount || 0).toLocaleString()}
                         </small>
                        {booking.payment_status === "paid" ? (
                           <small className="text-success d-block fw-semibold">
                             Paid
                           </small>
                         ) : (
                           <small className="text-muted d-block">
                             Unpaid: PKR {(booking.remaining_amount || 0).toLocaleString()}
                           </small>
                         )}
                        </td>

                      <td data-label="Guests">
                        {booking.number_of_guests || "N/A"}
                      </td>

                      <td data-label="Status">
                        <span
                          className={`hotel-status-badge ${getStatusClass(
                            booking.booking_status
                          )}`}
                        >
                          {booking.booking_status
                            ? booking.booking_status.charAt(0).toUpperCase() +
                            booking.booking_status.slice(1)
                            : "N/A"}
                        </span>
                      </td>

                      <td data-label="Actions">
                        <div className="hotel-action-buttons">
                          <button
                            className="hotel-action-btn hotel-edit-btn"
                            title="Edit"
                            onClick={() => openEditModal(booking)}
                          >
                            <PencilSquare className="hotel-action-icon" />
                          </button>
                          <button
                           className={`hotel-action-btn hotel-payment-btn ${
                             booking.payment_status === "paid" ? "hotel-payment-btn-done" : ""
                           }`}
                           title={
                             booking.payment_status === "paid"
                               ? "Payment received"
                               : "Mark remaining payment as received"
                           }
                           disabled={booking.booking_status !== "confirmed" || booking.payment_status !== "partial_paid"}
                           onClick={() => markPaymentReceived(booking.id)}
                           >
                           {booking.payment_status === "paid" ? (
                             <CheckCircleFill className="hotel-action-icon" />
                           ) : (
                             <CashStack className="hotel-action-icon" />
                           )}
                         </button>
                          <button
                            style={viewBtnStyle}
                            title="View Full Detail"
                            onClick={() =>
                              navigate(
                                `/vendor/hotel-bookings/detail/${booking.id}`,
                                { state: { booking } }
                              )
                            }
                          >
                            <Eye size={12} /> Detail
                          </button>
                        </div>
                      </td>

                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>

          {/* Empty state */}
          {bookings.length === 0 && (
            <div className="hotel-empty-state">
              <p className="text-muted">
                {filter === "All"
                  ? "No bookings found."
                  : `No ${filter} bookings found.`}
              </p>
            </div>
          )}

        </div>

        <ModalBooking
          show={showModal}
          handleClose={closeModal}
          booking={selectedBooking}
          mode={modalMode}
          loading={loading}
          onSave={saveBooking}
        />

      </div>
    </VendorLayout>
  );
};

export default HotelBookings;